'use client';

import type { ReactNode } from 'react';

// TODO: look at how we're using it to see if it makes sense to treat differently
const icon = <span className="fa-fw icon-blank">&nbsp;</span>;

export function BlankIcon(): ReactNode {
	return icon;
}
